import React, { useState } from 'react';
import { LightbulbIcon, TargetIcon } from 'lucide-react';
import { samplePrompts } from '../../data/samplePrompts';
import { PromptFlow } from './PromptFlow';
import { PromptDemo } from './PromptDemo';
import { PromptCard } from './PromptCard';
import { AiSafeguards } from './AiSafeguards';
export function PromptExplainer() {
  const [active, setActive] = useState(0);
  const current = samplePrompts[active];
  return <section aria-label="What is an AI prompt" className="border-t border-plum/10 bg-cream" data-id="element-214" data-mp="37mbc1bhphbq1">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "22px"
    }} data-id="element-215" data-mp="3coaf0k9ja6mg">
        <div className="text-center" data-id="element-216" data-mp="2yosljrlam56r">
          <h2 className="font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-217" data-mp="33lre45pb642u">🧠 What is an AI prompt?</h2>
          <p className="mx-auto mt-3 max-w-2xl text-base text-plum/70" data-id="element-218" data-mp="wv1sldn2blcn">
            An AI prompt is an <span className="font-bold text-grape" data-id="element-219" data-mp="11ueffydxosf8">instruction</span> that tells an AI assistant what task to
            perform, what information to consider, and how to organize its response. Instead of simply asking AI to “write a
            proposal,” a structured prompt guides the process through specific project details, deliverables, assumptions,
            and output requirements.
          </p>
        </div>

        <PromptFlow data-id="element-220" data-mp="359p7ajdjw8va" />
        <PromptDemo data-id="element-221" data-mp="3597fq01u2itp" />

        <div className="mx-auto mt-14 max-w-3xl" data-id="element-222" data-mp="35aqtnk00ohsb">
          <h3 className="text-center font-display text-xl font-black text-plum sm:text-2xl" data-id="element-223" data-mp="2hibi2map4tej">
            ✍️ See an example of the system in action
          </h3>
          <p className="mx-auto mt-2 max-w-xl text-center text-sm text-plum/60" data-id="element-224" data-mp="2rh9ba2j2hb3v">
            <span className="font-bold text-plum" data-id="element-225" data-mp="2rf6d2v7rgbo2">Purpose:</span> {current.purpose}
          </p>

          {samplePrompts.length > 1 && <div role="tablist" aria-label="Example prompts" className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-226" data-mp="6qs0ueornrkw">
              {samplePrompts.map((sp, i) => <button key={sp.n} role="tab" type="button" aria-selected={active === i} onClick={() => setActive(i)} className={`rounded-full px-4 py-2 text-xs font-bold transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-grape/40 ${active === i ? 'bg-plum text-white' : 'border border-plum/15 bg-white text-plum/70 hover:text-plum'}`} data-id="element-227" data-mp="1r5r4f85ctgu" data-mpi={i}>
                  #{sp.n} · {sp.title}
                </button>)}
            </div>}

          <div className="mt-5" data-id="element-228" data-mp="3majvqu7rnj14">
            <PromptCard key={current.n} prompt={current} data-id="element-229" data-mp="3mbmo76kqltj5" />
          </div>

          <div className="mt-5 grid gap-4 sm:grid-cols-2" data-id="element-230" data-mp="3r8d5fx8a2v65">
            <div className="rounded-2xl border border-plum/10 bg-white p-5" data-id="element-231" data-mp="3r6saw7lyrc8a">
              <p className="flex items-center gap-2 text-xs font-black uppercase tracking-wider text-plum" data-id="element-232" data-mp="1ipkt8wzm50">
                <TargetIcon className="h-4 w-4 text-grape" aria-hidden="true" data-id="element-233" data-mp="4vmxpftx207o" /> Expected output
              </p>
              <p className="mt-2 text-sm leading-relaxed text-plum/70" data-id="element-234" data-mp="38in935ova1c4">{current.expectedOutput}</p>
            </div>
            <div className="rounded-2xl border border-grape/30 bg-lilac-soft p-5" data-id="element-235" data-mp="30yujq1a9tobo">
              <p className="flex items-center gap-2 text-xs font-black uppercase tracking-wider text-grape-deep" data-id="element-236" data-mp="2w01dmtxbczlj">
                <LightbulbIcon className="h-4 w-4" aria-hidden="true" data-id="element-237" data-mp="2r0ojdo444q8x" /> Pro tip
              </p>
              <p className="mt-2 text-sm leading-relaxed text-plum/75" data-id="element-238" data-mp="2m23o833pwwrc">{current.proTip}</p>
            </div>
          </div>
          <p className="mt-3 text-center text-xs text-plum/50" data-id="element-239" data-mp="2i1bgjeahuzx6">
            This is an illustrative example. The full product contains additional prompts covering all six stages of the proposal process.
          </p>
        </div>

        <AiSafeguards data-id="element-240" data-mp="28aqa54okwr3p" />
      </div>
    </section>;
}